const en = {
    microspec: "Microspec",
    goBackToHome: "Go Back to Home",
    signIn: "Sign In",
    optional: "Optional",
    userSettings: "User Settings",
    users: "Users",
    manageUsers: "Manage Users",
    logout: "Logout",
    account: "Account",
    security: "Security",
    firstName: "First Name",
    lastName: "Last Name",
    emailAddress: "Email Address",
    phone: "Phone",
    password: "Password",
    address: "Address",
    save: "Save",
    saving: "Saving...",
    dangerZone: "Danger Zone",
    dangerZoneDeleteAccountText: "Click on the button below, in order to delete the account.",
    // Login method selection
    selectLoginMethod: "Select Login Method",
    selectRegistrationMethod: "Select Registration Method",
    chooseLoginMethod: "Choose Login Method",
    email: "Email",
    phoneNumber: "Phone Number",
    loginError: "Login error, please try again",
    languages: "Languages",
    notifications: "Notifications",
    noNewNotifications: "No new notifications",
    getResetLinkAfterButtonClick: "Click on the button below to get a reset link to your email.",
    getResetLink: "Get reset link",
    passwordReset: "Reset Password",
    simpleElementText: "Let's create an awesome page by Microspec UI Foundation",
    pleaseWait: "Please Wait",
    deleteAccount: "Delete Account",
    cancel: "Cancel",
    confirm: "Confirm",
    deleteAccountConfirmationDialogText: "Please confirm account deletion",
    emailOrPasswordInvalid: "The email or password is invalid.",
    rememberMe: "Remember Me",
    forgotPassword: "Forgot password?",
    newAccount: "New Account?",
    signUp: "Sign me up",
    joinUsToday: "Join us today",
    signUpError: "An error occurred, the email may already be registered or the password does not meet security requirements, please try again.",
    signUpInProgress: "Creating account...",
    resetLinkSuccessfullySent: "Reset link is successfully sent to your email, please check it.",
    errorTryLater: "Something went wrong, please try again later.",
    new: "New",
    newUnreadNotifications: "You have {0} unread messages",
    notificationsWaitMessage: "Please wait while we retrieve notifications",
    viewAll: "View All",
    invalidPhone: "Invalid phone number",
    invalidAddress: "Invalid address",
    aboutYourself: "Write about yourself",
    welcomeBack: "Welcome back",
    loggingInProgress: "Logging in...",
    formProgress: "Form Progress",
    additionalInformation: "Additional Information",
    // New authentication translations
    signingIn: "Signing in...",
    verificationCode: "Verification Code",
    otpSentMessage: "Verification code sent to your phone",
    verifyAndSignIn: "Verify & Sign In",
    verifying: "Verifying...",
    resendOtp: "Resend code",
    sendingOtp: "Sending...",
    resendOtpIn: "Resend code in {seconds} seconds",
    backToEmailSelection: "Back to email selection",
    backToPhoneSelection: "Back to phone selection",
    userNotFound: "User not found. Please check your details.",
    errorCheckingUser: "Error checking user. Please try again.",
    invalidCredentials: "Invalid email or password",
    enterYourPassword: "Enter your password",
    enterVerificationCode: "Enter the verification code sent",
    // Email verification translations
    verifyEmail: "Verify Your Email",
    verificationEmailSent: "We've sent a verification email to",
    checkEmailInstructions: "Please check your email and click the verification link to continue.",
    resendVerification: "Resend Verification Email",
    verificationEmailResent: "Verification email has been resent successfully!",
    verificationEmailError: "Failed to resend verification email. Please try again.",
    checkVerificationStatus: "I've Verified My Email",
    checkingVerificationStatus: "Checking verification status...",
    checking: "Checking...",
    sending: "Sending...",
    emailVerified: "Email Verified!",
    emailVerifiedMessage: "Your email has been successfully verified. Redirecting...",
    didntReceiveEmail: "Didn't receive the email?",
    checkSpamFolder: "Check your spam folder or click resend above.",
    backToLogin: "← Back to Login",
    tryDifferentEmail: "Try Different Email →",
    // OTP related translations
    invalidOtp: "Invalid verification code. Please try again.",
    otpVerificationFailed: "OTP verification failed. Please try again.",
    failedToResendOtp: "Failed to resend verification code. Please try again.",
    // Profile completion
    completeYourProfile: "Complete Your Profile",
    profileCompletionDescription: "Please enter your first and last name to complete registration",
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    completeProfile: "Complete Profile",
    creatingProfile: "Creating profile...",
    registrationEmail: "Email:",
    registrationPhone: "Phone:",
    back: "Back",
    emailRegistrationNotAvailable: "Email registration is not currently available. Please use your phone number.",
    otpSentSuccessfully: "Verification code sent successfully",
    id: "ID",
    internalId: "Internal ID",
    createdAt: "Created At",
    updatedAt: "Updated At",
    unnamedOrganization: "Unnamed Organization",
    noDescriptionProvided: "No description provided",
    failedToLoadOrganization: "Failed to load organizations. Please try again.",
    // 404 Page translations
    notFoundTitle: "Oops! Lost in Space",
    notFoundSubtitle: "The page you're looking for has drifted into the digital void. Don't worry, even the best explorers sometimes take a wrong turn!",
    notFoundBackToHome: "Back to Home",
    notFoundTryAgain: "Try Again",
    notFoundQuickNavigation: "Quick Navigation",
    notFoundErrorCode: "Error 404",
    notFoundPageLabel: "Page Not Found",
    notFoundHome: "Home",
    dragNDrop: "Drag & drop some files here, or click to select files",
    // Authentication error messages
    failedToSendOtp: "Failed to send OTP. Please try again.",
    failedToSendVerificationCode: "Failed to send verification code. Please try again.",
    failedToCreateProfile: "Failed to create profile. Please try again.",
    userAuthenticationMissing: "User authentication information missing",
    noConfirmationResult: "No confirmation result found. Please try again.",
    // Loader messages
    loadingInitialData: "Loading initial data...",
    loadingApplicationData: "Loading application data...",
    loadingUserProfile: "Loading user profile...",
    // Registration messages
    createNewAccount: "Create New Account",
    createNewPasswordDescription: "Create a new password for your account",
    enterNewPassword: "Enter new password",
    confirmNewPassword: "Confirm new password",
    newAccountCreationNotice: "A new account will be created with this email address",
    passwordRequirements: "Password must be at least 8 characters long",
    creatingAccount: "Creating account...",
    createAccount: "Create Account",
    registrationError: "Registration failed. Please try again.",
    passwordRequired: "Password is required",
    passwordTooShort: "Password must be at least 8 characters",
    passwordsDoNotMatch: "Passwords do not match",
    emailAlreadyInUse: "This email is already registered. Please try signing in instead.",
    invalidEmail: "Invalid email address",
    // Notice for automatic account creation during login
    newAccountAutoCreationNoticeForEmail: "If there is no account associated with this email address, you will be notified to create a new account and you'll be guided through the registration process",
    newAccountAutoCreationNoticeForPhone: "If there is no account associated with this phone number, you will be notified to create a new account and you'll be guided through the registration process",
    // Account form translations
    updateYourAccountInfo: "Update your account information and preferences",
    personalInformation: "Personal Information",
    contactInformation: "Contact Information",
    fieldRequired: "This field is required",
    pleaseFixErrors: "Please fix the errors before submitting",
    profileUpdatedSuccessfully: "Profile updated successfully!",
    verifiedField: "This field is verified and cannot be changed",
    // Profile picture translations
    changeProfilePicture: "Change Profile Picture",
    selectProfilePicture: "Select Profile Picture",
    selectImageDescription: "Choose an image to upload as your profile picture. You'll be able to crop and adjust it before saving.",
    clickToUpload: "Click to Upload",
    selectImage: "Select Image",
    cropYourImage: "Crop Your Image",
    uploadingProfilePicture: "Uploading Profile Picture...",
    profilePictureUpdated: "Profile picture updated successfully!",
    failedToUpdateProfilePicture: "Failed to update profile picture. Please try again.",
    invalidFileType: "Please select an image file",
    fileTooLarge: "File size must be less than 10MB",
    selectDifferent: "Select Different",
    saveProfilePicture: "Save Profile Picture",
    // Generic image upload translations
    uploadImage: "Upload Image",
    imageUploadedSuccessfully: "Image uploaded successfully!",
    failedToUploadImage: "Failed to upload image. Please try again.",
    uploadingImage: "Uploading Image...",
    saveImage: "Save Image",
    changeProfilePictureDescription: "Choose an image to upload as your profile picture. You'll be able to crop and adjust it before saving.",
    // Logo upload translations
    uploadLogo: "Upload Logo",
    changeLogo: "Change Logo",
    uploadLogoDescription: "Choose an image to upload as your logo. You'll be able to crop and adjust it before saving.",
    logo: "Logo",
    // User existence messages
    userAlreadyExists: "This account already exists. Please sign in instead.",
    userNotFoundPleaseRegister: "No account found with this information. Please register first.",
    dashboard: "Dashboard",
    systemAdminDashboard: "System Admin Dashboard",
    // Organization management translations
    organizationName: "Organization Name",
    organizationDescription: "Organization Description",
    organizations: "Organization",
    manageOrganization: "Manage Organization",
    addOrganization: "Add Organization",
    editOrganization: "Edit Organization",
    loadingOrganization: "Loading organization...",
    noOrganizationFound: "No organizations found.",
    loadMore: "Load More",
    createFirstOrganization: "Create First Organization",
    createOrganization: "Create Organization",
    // Branch management translations
    branches: "Branches",
    manageBranches: "Manage Branches",
    addBranch: "Add Branch",
    loadingBranches: "Loading Branches...",
    editBranch: "Edit Branch",
    branchName: "Branch Name",
    branchNameRequired: "Branch Name *",
    branchNameIsRequired: "Branch name is required",
    branchNotFound: "Branch not found",
    failedToLoadBranch: "Failed to load branch data",
    failedToSaveBranch: "Failed to save branch",
    branchUpdatedSuccessfully: "Branch updated successfully!",
    branchCreatedSuccessfully: "Branch created successfully!",
    updateBranchInfo: "Update branch information and settings",
    fillBranchDetails: "Fill in the details to create a new branch",
    updateBranch: "Update Branch",
    createBranch: "Create Branch",
    location: "Location",
    city: "City",
    state: "State",
    zipCode: "ZIP Code",
    country: "Country",
    // UpsertOrganization component
    organizationNotFound: "Organization not found",
    basicInformation: "Basic Information",
    organizationNameRequired: "Organization Name *",
    industry: "Industry",
    selectIndustry: "Select Industry",
    description: "Description",
    organizationDescriptionPlaceholder: "Enter a brief description of your organization...",
    emailAddressRequired: "Email Address *",
    branding: "Branding",
    remove: "Remove",
    primaryColor: "Primary Color",
    secondaryColor: "Secondary Color",
    settings: "Settings",
    primaryCurrency: "Primary Currency",
    supportedCurrencies: "Supported Currencies",
    localization: "Localization",
    language: "Language",
    preferredLanguage: "Preferred Language",
    supportedLanguages: "Supported Languages",
    updateOrganizationInfo: "Update organization information and settings",
    fillOrganizationDetails: "Fill in the details to create a new organization",
    organizationUpdatedSuccessfully: "Organization updated successfully!",
    organizationCreatedSuccessfully: "Organization created successfully!",
    organizationNameIsRequired: "Organization name is required",
    contactEmailIsRequired: "Contact email is required",
    pleaseEnterValidEmail: "Please enter a valid email address",
    pleaseEnterValidPhone: "Please enter a valid phone number",
    pleaseEnterValidHexColor: "Please enter a valid hex color",
    pleaseSelectImageFile: "Please select an image file",
    imageSizeLessThan5MB: "Image size should be less than 5MB",
    pleaseFixFormErrors: "Please fix the form errors before submitting",
    userNotAuthenticated: "User not authenticated",
    systemError: "System error. Please try again later.",
    organizationInfoMissing: "Organization information is missing.",
    organizationOwnershipInfoMissing: "Organization ownership information is not configured.",
    unauthorized: "You don't have permission to access this page.",
    verificationError: "An error occurred while verifying your access. Please try again.",
    accessDenied: "Access Denied",
    failedToSaveOrganization: "Failed to save organization",
    updating: "Updating...",
    updateOrganization: "Update Organization",
    creating: "Creating...",
    restaurant: "Restaurant",
    technology: "Technology",
    healthcare: "Healthcare",
    finance: "Finance",
    education: "Education",
    retail: "Retail",
    manufacturing: "Manufacturing",
    construction: "Construction",
    foodAndBeverage: "Food & Beverage",
    transportation: "Transportation",
    realEstate: "Real Estate",
    marketing: "Marketing",
    consulting: "Consulting",
    other: "Other",
    arabicSaudi: "Arabic (Saudi Arabia)",
    hebrewIsrael: "Hebrew (Israel)",
    englishUS: "English (US)",
    pageNotFound: "Page Not Found",
    pageNotFoundText: "The page you are looking for does not exist.",
    yearsOfExperience: "Years of Experience",
    loadingDashboard: "Loading Dashboard...",
    brandingStatistics: "Branding Statistics",
    withLogos: "With Logos",
    withBranding: "With Branding",
    currencyStatistics: "Currency Statistics",
    totalCurrenciesSupported: "Total Currencies Supported",
    activityOverview: "Activity Overview",
    organizationsLastMonth: "Organization Created Last Month",
    ofTotal: "of total",
    currenciesBreakdown: "Currencies Breakdown",
    totalOrganization: "Total Organization",
    totalUsers: "Total Users",
    of: "of",
    rowsPerPage: "Rows per page",
    search: "Search",
    items: "items",
    noDataAvailable: "No data available",
    actions: "Actions",
    refresh: "Refresh",
    export: "Export",
    columnSettings: "Column Settings",
    selected: "selected",
    moreThan: "more than",
    exportData: "Export Data",
    exportFormat: "Export Format",
    exportScope: "Export Scope",
    currentPage: "Current Page",
    pageRange: "Page Range",
    allPages: "All Pages",
    fromPage: "From Page",
    toPage: "To Page",
    exportInfo: "Export Info",
    // Organization Context
    workspaceContext: "Workspace Context",
    selectOrganization: "Select Organization",
    selectBranch: "Select Branch",
    allBranches: "All Branches",
    currentContext: "Current Context",
    noOrganizationMembership: "Not a member of any organization",
    noOrganizationMembershipDescription: "You need to be part of an organization to access this content. Please contact your administrator to be added to an organization.",
    loadingOrganizationContext: "Loading workspace context...",
    retry: "Retry",
    roles: "roles",
    nextSteps: "Next Steps",
    contactOrganizationAdmin: "Contact Organization Administrator",
    contactOrganizationAdminDescription: "Reach out to your organization's administrator to request access.",
    waitForInvitation: "Wait for Invitation",
    waitForInvitationDescription: "Once invited, you'll be able to access the dashboard and its features.",
    checkForMemberships: "Check for Memberships",
    organizationsManager: "Organizations Manager",
    // UpsertMemberToOrganization component
    assignMemberToOrganization: "Assign Member to Organization",
    findUser: "Find User",
    assignRoles: "Assign Roles",
    organizationIdRequired: "Organization ID is required",
    failedToValidateIds: "Failed to validate organization/branch IDs",
    pleaseEnterSearchValue: "Please enter an email or phone number",
    failedToSearchUser: "Failed to search for user",
    pleaseSelectUser: "Please select a user",
    pleaseSelectAtLeastOneRole: "Please select at least one role",
    failedToAssignMember: "Failed to assign member",
    memberAlreadyInBranch: "Member already exists in the selected branch",
    memberAssignedSuccessfully: "Member Assigned Successfully",
    userAddedToOrgAndBranch: "User has been added to the organization and branch with the selected roles.",
    userAddedToOrg: "User has been added to the organization with the selected roles.",
    addAnotherMember: "Add Another Member",
    close: "Close",
    findUserToAdd: "Find User to Add",
    searchByEmail: "Search by Email",
    searchByPhone: "Search by Phone",
    searchByEmailOrPhone: "Search by Email or Phone",
    searchResults: "Search Results",
    selectRolesForMember: "Select the roles you want to assign to this member.",
    organizationRoles: "Organization Roles",
    branchRoles: "Branch Roles",
    confirmAssignment: "Confirm Assignment",
    user: "User",
    memberWillReceiveNotification: "The member will receive a notification about their new role.",
    assignMember: "Assign Member",
    next: "Next",
    validatingInformation: "Validating information...",
    userAlreadyOrgMember: "This user is already an active member of this organization",
    userAlreadyOrgMemberCanAddToBranch: "This user is already a member of the organization and will be added to the selected branch",
    userAlreadyBranchMember: "This user is already an active member of this branch",
    selectOrganizationAndBranch: "Select Organization and Branch",
    selectBranchOptional: "Select Branch (Optional)",
    pleaseSelectOrganization: "Please select an organization",
    failedToLoadOrganizations: "Failed to load organizations",
    userWillBeAssignedToBranch: "User will be assigned to the selected organization and branch",
    userWillBeAssignedToOrg: "User will be assigned to the selected organization only",
    selectedUser: "Selected User",
    userFound: "User Found",
    identifier: "Identifier",
    authenticationMethod: "Authentication Method",
    availableMethods: "Available Methods",
    errorSearchingUser: "An error occurred while searching for the user. Please try again.",
    // ManageMembers component
    branchMembers: "Branch Members",
    organizationMembers: "Organization Members",
    noBranchesFound: "No branches found",
    unnamedBranch: "Unnamed Branch",
    memberAddedSuccessfully: "Member added successfully",
    memberSuspended: "Member suspended successfully",
    memberActivated: "Member activated successfully",
    memberRemoved: "Member removed successfully",
    failedToUpdateMember: "Failed to update member",
    failedToRemoveMember: "Failed to remove member",
    member: "Member",
    manageMembers: "Manage Members",
    status: "Status",
    noRoles: "No roles assigned",
    active: "Active",
    suspended: "Suspended",
    invited: "Invited",
    transferred: "Transferred",
    joinedAt: "Joined At",
    notYetJoined: "Not yet joined",
    addedOn: "Added On",
    addMember: "Add Member",
    suspend: "Suspend",
    activate: "Activate",
    noMembers: "No members found",
    suspendMember: "Suspend Member",
    activateMember: "Activate Member",
    suspendMemberConfirm: "Are you sure you want to suspend this member? They will lose access to the organization/branch.",
    activateMemberConfirm: "Are you sure you want to activate this member? They will regain access to the organization/branch.",
    removeMember: "Remove Member",
    removeMemberWarning: "This action cannot be undone. The member will be permanently removed.",
    removeMemberConfirm: "Are you sure you want to remove this member?",
    processing: "Processing...",
    unknownUser: "Unknown User",
    loading: "Loading...",
    ecommerceBusinessManager: "Ecommerce Business Manager",
    manageModules: "Manage Modules",
    modules: "Modules",
    addModule: "Add Module",
    enablableModules: "Enablable Modules",
    manageSystemModules: "Enable or disable system modules to customize your platform experience",
    enabled: "Enabled",
    disabled: "Disabled",
    organizationContextAware: "Organization Context Aware",
    noEnablableModules: "No Enablable Modules",
    noModulesAvailable: "There are currently no modules available to enable or disable",
    enableModule: "Enable Module",
    disableModule: "Disable Module",
    enableModuleConfirmation: "This will enable the module for 14 days. The module will be accessible to your organization during this period.",
    disableModuleConfirmation: "This will disable the module immediately. Users will no longer have access to this module's features.",
    module: "Module",
    activePeriod: "Active Period",
    startDate: "Start Date",
    endDate: "End Date",
    // Module access control translations
    moduleNotEnabled: "Module Not Enabled",
    moduleNotEnabledDescription: "This module is not currently enabled for your organization. Please contact your administrator to enable access to this feature.",
    requestedModule: "Requested Module",
    currentOrganization: "Current Organization",
    moduleEnableInstructions: "To enable this module, visit the Modules management page in Organization Admin settings and activate it for your organization.",
    goToModules: "Go to Modules",
    goBack: "Go Back",
    // Organizational Layout translations
    loadingOrganizationData: "Loading organizational data...",
    illegalState: "Invalid Request",
    illegalStateDescription: "This page requires valid organization information to display content. Please access this page through the proper navigation.",
    organizationNotFoundDescription: "The organization you're looking for doesn't exist or has been removed. Please check the organization ID and try again.",
    branchNotFoundForOrganization: "Branch Not Found",
    branchNotFoundForOrganizationDescription: "The requested branch doesn't exist within this organization. It may have been removed or the branch ID is incorrect.",
    unexpectedError: "Something Went Wrong",
    unexpectedErrorDescription: "An unexpected error occurred while loading the organizational data. Please try again later or contact support if the problem persists.",
    // Permissions Management translations
    permissionsManagement: "Permissions Management",
    permissionsManagementDescription: "View and synchronize system permissions with the database",
    manageAuthentication: "Manage Authentication",
    filterByModule: "Filter by Module",
    allModules: "All Modules",
    synced: "Synced",
    notSynced: "Not Synced",
    syncAll: "Sync All",
    syncing: "Syncing...",
    syncToDatabase: "Sync to Database",
    permissionId: "Permission ID",
    displayName: "Display Name",
    total: "Total",
    // Permission names
    manageOrganizationsPermission: "Manage Organizations",
    manageOrganizationsPermissionDesc: "Create, edit, and delete organizations",
    manageUsersPermission: "Manage Users",
    manageUsersPermissionDesc: "Create, edit, and manage user accounts",
    manageModulesPermission: "Manage Modules",
    manageModulesPermissionDesc: "Enable or disable system modules",
    managePermissionsPermission: "Manage Permissions",
    managePermissionsPermissionDesc: "Configure and assign permissions",
    manageProductsPermission: "Manage Products",
    manageProductsPermissionDesc: "Create, edit, and manage product catalog",
    manageOrdersPermission: "Manage Orders",
    manageOrdersPermissionDesc: "View and process customer orders",
    viewAnalyticsPermission: "View Analytics",
    viewAnalyticsPermissionDesc: "Access business analytics and reports",
    manageCustomersPermission: "Manage Customers",
    manageCustomersPermissionDesc: "View and manage customer information",
    noPermissionsFound: "No permissions found",
    all: "الكل",
    createdWithLove: "Created with love ❤️ by Microspec",
    copyrightsReserved: "All rights reserved",
    learnMore: "Learn More",
    faqTitle: "Frequently Asked Questions",
    faqSubtitle: "Find answers to common questions about our services",
    faqSearchPlaceholder: "Search for a question...",
    noFaqSearchResults: "No FAQ search results found",
    lightMode: "Light Mode",
    darkMode: "Dark Mode",
    contactUs: "Contact Us",
    submit: "Submit",
    clear: "Clear",
    formSuccessMessage: "Form submitted successfully!",
    fullName: "Full Name",
    message: "Message",
    // Localized Input
    localizedInputManageLocalizations: "Manage Localizations",
    localizedInputClickIconToLocalize: "Click the language icon to localize for all languages",
    localizedInputEditAllLanguages: "Edit values for all supported languages",
    localizedInputPreferred: "Preferred",
    localizedInputEnterValue: "Enter value",
}

const getEnglishMap = () => {
    return en
}

export default getEnglishMap